import { MarketContentDesignExperimentVariants } from './content-marketing';

const getControl = ({
    escapedImgUrl,
    escapedSponsor,
    escapedIconUrl,
    escapedHref,
    escapedTitle,
    escapedText,
}) => {
    return /*html*/ `
    <div class="flex w-full justify-between items-center bg-white px-16 py-8">
        <div class="text-12">Annonsørinnhold</div>
        <img alt="${escapedSponsor}" class="h-16" src="${escapedIconUrl}">
    </div>
    <img alt="Annonsebilde" class="h-290 w-full object-cover" src="${escapedImgUrl}">
    <h3 class="h2 md:h1 font-normal text-gray-400 ml-16 mt-16 mr-16" id="title_id">
        <a style="text-decoration: none;" class="link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring" href="${escapedHref}" target="_blank" title="${escapedTitle}">
            <span aria-hidden="true" class="inset-0 absolute"></span>${escapedTitle}
        </a>
    </h3>
    <p class="text-14 text-gray-400 mb-4 ml-16 mb-16 mr-16">${escapedText}</p>
    `;
};

const getChallengerLargerWhiteStripe = ({
    escapedImgUrl,
    escapedSponsor,
    escapedIconUrl,
    escapedHref,
    escapedTitle,
    escapedText,
}) => {
    return /*html*/ `
    <div class="flex w-full justify-between items-center bg-white px-16 py-16">
        <div class="text-14">Annonsørinnhold</div>
        <img alt="${escapedSponsor}" class="h-24" src="${escapedIconUrl}">
    </div>
    <img alt="Annonsebilde" class="h-290 w-full object-cover" src="${escapedImgUrl}">
    <h3 class="h2 md:h1 font-normal text-gray-400 ml-16 mt-16 mr-16" id="title_id">
        <a style="text-decoration: none;" class="link link--dark sf-ad-link text-gray-700 hover:no-underline focus:no-underline focus-ring" href="${escapedHref}" target="_blank" title="${escapedTitle}">
            <span aria-hidden="true" class="inset-0 absolute"></span>${escapedTitle}
        </a>
    </h3>
    <p class="text-14 text-gray-400 mb-4 ml-16 mb-16 mr-16">${escapedText}</p>
    `;
};

const getArticleWrapper = (isFrontpage, children: string) => {
    const articleStyleVariant = isFrontpage ? '' : 'mt-24 mx-16';

    return /*html*/ `
    <article
        class="relative overflow-hidden transition-all outline-none sf-ad-outline
        sf-ad-card rounded-8 ${articleStyleVariant} mb-auto sm:mb-24 relative"
        tabindex="0">
      <button class="sr-only" tabindex="-1">Velg</button>
      <div aria-owns="title_id"></div>
      ${children}
    </article>`;
};

export const getHtml = (
    isFrontpage,
    htmlContent,
    variant: MarketContentDesignExperimentVariants,
) => {
    switch (variant) {
        case 'control':
            return getArticleWrapper(isFrontpage, getControl(htmlContent));
        case 'challengerLargerStripAndLogo':
            return getArticleWrapper(
                isFrontpage,
                getChallengerLargerWhiteStripe(htmlContent),
            );
        default:
            return getArticleWrapper(isFrontpage, getControl(htmlContent));
    }
};
